import { Clear } from '@mui/icons-material';
import { ListItem, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import { FC } from 'react';
import { emptyValue } from '@/types/detail';
import { ConfigurationVariable } from '@/types/metadata/metadata';
import { KeyValue, VariableRef } from '@/types/variable';
import { kvVariablesListUtil } from '@/util/validation/kvvariableslist';
import ConfirmPopover from '@/components/common/ConfirmPopover';
import List from '@/components/common/List';
import ListArrows from '@/components/common/ListArrows';
import TextFieldWrapper from '@/components/common/TextFieldWrapper';
import { ParamProps } from './ParamRenderer';
import VariableView from './VariableView';

const ParamKvVariablesList: FC<ParamProps> = (props) => {
  const theme = useTheme();
  const configuration = props.configuration as ConfigurationVariable;

  const initialValue = kvVariablesListUtil().getValue(props.configuration, props.initialValue);

  const removeEntry = (indexToRemove: number, values: KeyValue<VariableRef | emptyValue | undefined>[]) => {
    const newInitialValue = values.filter((_, index) => index !== indexToRemove);
    props.onChange([props.configuration.value, newInitialValue]);
  };

  return (
    <List
      subheader={configuration.value + (props.configuration.required ? ' *' : '')}
      {...(!!props.errors?.length && {
        subheaderSx: { color: theme.palette.error.main }
      })}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start'
      }}
    >
      {initialValue?.map((kvObject, index) => (
        <ListItem key={`varlist.${index}`}>
          <TextFieldWrapper
            size='small'
            label={'key'}
            value={kvObject.key}
            onChange={(e) => {
              initialValue[index].key = e.currentTarget.value;
              props.onChange([configuration.value, initialValue]);
            }}
          />
          <VariableView
            subroutineId={props.parentId}
            type={configuration.subtype || 'any'}
            valueKey={configuration.value}
            onChange={(newVariable) => {
              initialValue[index].value = newVariable ? newVariable : ({} as VariableRef);
              props.onChange([configuration.value, initialValue]);
            }}
            initialValue={kvObject.value}
            allowEmpty
          />
          <ListArrows
            data={initialValue}
            index={index}
            onChange={(result) => props.onChange([props.configuration.value, result])}
          />
          <ConfirmPopover
            onConfirm={() => removeEntry(index, initialValue)}
            icon={<Clear />}
            skipConfirm={Object.keys(kvObject).length === 0}
            text={
              <>
                Remove <code>{kvObject.key}</code> from list?
              </>
            }
          />
        </ListItem>
      ))}
      <ListItem>
        <Button
          variant='contained'
          color='primary'
          onClick={() => props.onChange([configuration.value, initialValue ? [...initialValue, {}] : [{}]])}
        >
          Add variable
        </Button>
      </ListItem>
    </List>
  );
};

export default ParamKvVariablesList;
